/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CorrectionSource = {
    Text: 'text',
    Form: 'form',
    Reaction: 'reaction',
} as const;
export type CorrectionSource = typeof CorrectionSource[keyof typeof CorrectionSource];


export function instanceOfCorrectionSource(value: any): boolean {
    for (const key in CorrectionSource) {
        if (Object.prototype.hasOwnProperty.call(CorrectionSource, key)) {
            if (CorrectionSource[key as keyof typeof CorrectionSource] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CorrectionSourceFromJSON(json: any): CorrectionSource {
    return CorrectionSourceFromJSONTyped(json, false);
}

export function CorrectionSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CorrectionSource {
    return json as CorrectionSource;
}

export function CorrectionSourceToJSON(value?: CorrectionSource | null): any {
    return value as any;
}

export function CorrectionSourceToJSONTyped(value: any, ignoreDiscriminator: boolean): CorrectionSource {
    return value as CorrectionSource;
}

